import {
  categoryKeyToDisplayNameMap,
  pricingListCategoryToColumnMap,
} from './constants';

export const getPricingListTableColumn = (currentPath: string) => {
  return pricingListCategoryToColumnMap[currentPath] || [];
};

export const getDisplayNameForCategoryKey = (
  categoryKey: string
): string | undefined => {
  return categoryKeyToDisplayNameMap[categoryKey];
};
